import { PluginFunc, Dayjs } from "dayjs";
import parser from "cron-parser";

export interface CronOptions {
  timeZone?: string;
}

export interface FromCronOptions {
  baseTime?: Dayjs;
  timeZone?: string;
}

const dayjsCron: PluginFunc = (_opts, dayjsClass, dayjsFactory) => {
  // Generate a 6-field cron expression (min hour day month weekday year)
  dayjsClass.prototype.toCron = function (opts: CronOptions = {}): string {
    const local = opts.timeZone ? this.tz(opts.timeZone) : this;

    const minute = local.minute();
    const hour = local.hour();
    const day = local.date();
    const month = local.month() + 1; // month is 0-indexed
    const year = local.year();

    return `${minute} ${hour} ${day} ${month} * ${year}`;
  };

  // Parse cron and return next matching Dayjs
  dayjsFactory.fromCron = (
    expr: string,
    options: FromCronOptions = {}
  ): Dayjs => {
    const base = options.baseTime ?? dayjsFactory();
    const baseDate = options.timeZone
      ? base.tz(options.timeZone).toDate()
      : base.toDate();

    const interval = parser.parse(expr, {
      currentDate: baseDate,
      tz: options.timeZone,
    });

    const nextDate = interval.next().toDate();
    return options.timeZone
      ? dayjsFactory(nextDate).tz(options.timeZone)
      : dayjsFactory(nextDate);
  };
};

export default dayjsCron;
